import { render, staticRenderFns } from "./AppCalendarLayout.vue?vue&type=template&id=1e7c0860"
import script from "./AppCalendarLayout.vue?vue&type=script&lang=js"
export * from "./AppCalendarLayout.vue?vue&type=script&lang=js"
import style0 from "./AppCalendarLayout.vue?vue&type=style&index=0&id=1e7c0860&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QSeparator});
